import React, { useState, useRef, useEffect } from "react";
import { Loading } from "@networkraildigitalfactory/components";
import "./TabTable.css";

const TabTable = (props) => {
  const [activeTab, setActiveTab] = useState(props.defaultActive);
  // eslint-disable-next-line no-unused-vars
  const [tableContent, setTableContent] = useState();
  const contentRef = useRef();

  const updateActiveTab = (tab) => {
    if (props.onChangeTab) {
      props.onChangeTab(tab);
    }
    setActiveTab(tab);
  };

  useEffect(() => {
    const tableContent2 = contentRef.current.querySelectorAll("div");

    setTableContent(tableContent2.id);
  }, [contentRef.current]);

  return (
    <div className="TabTable" style={{ ...props.style }}>
      <div className="TabTable__tabs-wrapper">
        {props.tabs &&
          props.tabs.map((item, index) => (
            <div
              role="tab"
              key={index}
              aria-selected={activeTab === item.name.replace(" ", "").toLowerCase()}
              aria-controls={item.data.props.id}
              id={item.name.replace(" ", "").toLowerCase()}
              className={`TabTable__tab ${
                activeTab === item.name.replace(" ", "").toLowerCase() ? "active" : ""
              }`}
              style={{ width: props.tabs.length === 1 ? "400px" : "150px" }}
              onClick={() => {
                updateActiveTab(item.name.replace(" ", "").toLowerCase());
              }}
              tabIndex={props.tabs.length === 1 ? -1 : 0}
            >
              {item.name}
            </div>
          ))}
      </div>
      <div
        role="tabpanel"
        aria-labelledby={activeTab}
        className="TabTable__content"
        ref={contentRef}
      >
        {<Loading loading={props.loading} />}
        {!props.loading &&
          props.tabs.map((item) =>
            item.data && item.data.props.id === `${activeTab}Panel` ? (
              <React.Fragment key={item}>{item.data}</React.Fragment>
            ) : null
          )}
      </div>
    </div>
  );
};

export default TabTable;
